import { InputNumber } from 'antd';
import AwesomeDebouncePromise from 'awesome-debounce-promise';
import { useCallback, useEffect, useState } from 'react';
import useConstant from 'use-constant';

import { ValueInput } from './';

export function DebouncedInputNumber({
  disabled,
  loading: _loading,
  min,
  max,
  onChange,
  setSubmitLock,
  value: inputValue,
  ...props
}) {
  const [value, setValue] = useState(inputValue);

  useEffect(() => {
    setValue(inputValue);
  }, [inputValue]);

  const nullEmptyToUndef = x => (x === null || x === '' ? undefined : x);

  const dispatch = (val, onChange) => onChange(val);
  const debouncedOnChange = useConstant(() => AwesomeDebouncePromise(dispatch, 300));
  const callOnChange = useCallback(
    async (val, onChange) => {
      await debouncedOnChange(val, onChange);
      if (setSubmitLock) {
        setSubmitLock(false);
      }
    },
    [debouncedOnChange, setSubmitLock]
  );

  // FIXME: cant figure out how to incorporate "width" in editabledamageattributes
  return (
    <InputNumber
      defaultValue={value}
      min={min}
      max={max}
      disabled={disabled || max < min}
      {...(min === max && min !== undefined && min !== null ? { placeholder: min } : {})}
      onChange={val => {
        if (min !== undefined && val < min) {
          return;
        }
        if (max !== undefined && val > max) {
          return;
        }
        const newVal = nullEmptyToUndef(val);
        setValue(newVal);
        if (setSubmitLock) {
          setSubmitLock(true);
        }
        callOnChange(newVal, onChange);
      }}
      {...(min <= max ? { placeholder: `${min} to ${max}` } : {})}
      style={{ width: '100%' }}
      {...props}
      value={value}
    />
  );
}

export function DebouncedValueInput({ onChange, ...props }) {
  const dispatch = (val, onChange) => onChange(val);
  const debouncedOnChange = useConstant(() => AwesomeDebouncePromise(dispatch, 300));
  const callOnChange = useCallback(
    (val, onChange) => {
      debouncedOnChange(val, onChange);
    },
    [debouncedOnChange]
  );

  return (
    <ValueInput
      onChange={val => {
        callOnChange(val, onChange);
      }}
      {...props}
    />
  );
}
